import * as _ from "lodash";
import { Action } from "redux";
import * as Actions from "../actions/DeployActions";
import * as listActions from "../actions/ProcessListActions";
import { Process } from "../model/Process";

import { DeployDialogState } from "../model/DeployDialogState";

export function deployDialogState(state: DeployDialogState = new DeployDialogState(), action: Action): DeployDialogState {
    switch (action.type) {
        case Actions.OPEN_DEPLOY_MODAL:
            const deployAction = action as Actions.OpenDeployModalAction;
            return {
                showDeployDialog: true,
                warnApiPassthroughConfiguration: null,
                hasApiPassthroughConfiguration: false,
                isSwitchVersion: deployAction.isSwitchVersion,
                selectedProcesses: deployAction.processes,
                processVersions: deployAction.processVersions,
                versionsToDeploy: _.fromPairs(deployAction.processes.map((p) => [p.uniqueIdentifier, p.version])),
                targetAgentGroupName: deployAction.defaultTargetAgentGroupName,
                targetEnvironmentName: deployAction.defaultTargetEnvironmentName,
                availableAgentGroups: deployAction.availableAgentGroups,
                agentVersions: deployAction.agentVersions,
                suggestedProcessVariablesForDeployment: deployAction.suggestedProcessVariablesForDeployment,
        };
        case Actions.CLOSE_DEPLOY_MODAL:
            return new DeployDialogState();
        case Actions.SET_TARGET_AGENT_GROUP:
            const setAgentGroupAction = action as Actions.SetTargetAgentGroupAction;
            const stateCopyWithAgentGroup: DeployDialogState = Object.assign({}, state);
            stateCopyWithAgentGroup.targetAgentGroupName = setAgentGroupAction.agentGroup;
            stateCopyWithAgentGroup.targetEnvironmentName = setAgentGroupAction.environment;
            stateCopyWithAgentGroup.suggestedProcessVariablesForDeployment = setAgentGroupAction.suggestedProcessVariablesForDeployment;
            return stateCopyWithAgentGroup;

        case Actions.SET_VERSION_TO_DEPLOY_ACTION:
            const setVersionAction = action as Actions.SetVersionToDeployAction;
            const stateCopyWithDeploy = Object.assign({}, state) as DeployDialogState;
            stateCopyWithDeploy.versionsToDeploy = Object.assign({}, state.versionsToDeploy, {
                [setVersionAction.processGuid]: setVersionAction.version
            });

            const versionsOfProcess = stateCopyWithDeploy.processVersions[setVersionAction.processGuid];
            const previouslySelectedVersion = stateCopyWithDeploy.versionsToDeploy[setVersionAction.processGuid];
            const previouslySelectedProcessId = versionsOfProcess.find(v => v.version === previouslySelectedVersion)!.processId;
            delete stateCopyWithDeploy.suggestedProcessVariablesForDeployment[previouslySelectedProcessId];

            stateCopyWithDeploy.suggestedProcessVariablesForDeployment[setVersionAction.processId]= setVersionAction.suggestedProcessVariablesForDeployment;

            return stateCopyWithDeploy;
        default:
            return state;
    }
}
